import type AuthProvider from '$lib/components/auth/store.svelte';
import type { ICartItem } from '$lib/components/cart/store.svelte';

export class CriteoProvider {
	protected accountId: string;
	protected storeId: number;
	protected storeName: string;
	protected auth: AuthProvider;

	constructor(accountId: string, storeId: number, storeName: string, auth: AuthProvider) {
		this.accountId = accountId;
		this.storeId = storeId;
		this.storeName = storeName;
		this.auth = auth;
	}

	#trackEvent(events: Record<string, unknown>[]) {
		events.push(
			{ event: 'setAccount', account: this.accountId },
			{ event: 'setSiteType', type: 'd' },
		);

		const userData = this.auth.userData;
		if (userData) {
			events.push({ event: 'setCustomerId', id: userData.id });
			events.push({ event: 'setHashedEmail', email: userData.hashedEmail, hash_method: 'sha256' });
		}

		window.criteo_q = window.criteo_q || [];
		window.criteo_q.push(events);
	}

	trackBasket(cartItems: ICartItem[]) {
		if (cartItems[0].unit_price_excl_tax === undefined) {
			return;
		}

		this.#trackEvent([
			{
				event: 'viewBasket',
				product: cartItems.map((item) => ({
					id: item.sku,
					price: item.unit_price_excl_tax - item.discount_amount,
					quantity: item.quantity,
				})),
			},
		]);
	}

	trackTransaction(order: SalesOrder) {
		this.#trackEvent([
			{
				event: 'trackTransaction',
				id: order.ref,
				product: order.items.map((item) => ({
					id: item.sku,
					price: item.unit_price_excl_tax - item.discount_amount,
					quantity: item.quantity,
				})),
			},
		]);
	}

	trackViewList(productSkus: string[]) {
		// TODO : can't be usable at this time, missing product skus in the category products response

		this.#trackEvent([
			{
				event: 'viewList',
				product: productSkus,
			},
		]);
	}

	trackViewHome() {
		this.#trackEvent([{ event: 'viewHome' }]);
	}

	trackViewItem(productSkus: string[]) {
		this.#trackEvent(
			productSkus.map((sku) => ({
				event: 'viewItem',
				product: sku,
			})),
		);
	}
}

export default CriteoProvider;
